var scalpert = /** @class */ (function () {
    function scalpert() {
    }
    scalpert.STORE_MODULE_NAME = 'scalpert';
    return scalpert;
}());
export { scalpert };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/scalpert/lib/scalpert.cls.ts
// module id = VFZ7
// module chunks = 75